/**
 * Idle-warm header interaction modules so the first search / cart / mega-menu
 * open does not pay module compile + scroll-lock layout measurement costs.
 */
import { getScrollbarWidth } from '@theme/dialog'
import { requestIdleCallback } from '@theme/utilities'

/**
 * Measure scroll-lock chrome and evaluate open-path modules.
 * @returns {Promise<void>}
 */
export async function warmHeaderInteractionModules() {
  getScrollbarWidth()

  await Promise.allSettled([
    import('@theme/dialog'),
    import('@theme/focus'),
    import('@theme/morph'),
    import('@theme/section-renderer')
  ])
}

/**
 * Warm open-path modules and scroll-lock measurement after load settles.
 * Safe to call more than once; work is idle-only.
 */
export function warmHeaderInteractions() {
  requestIdleCallback(
    () => {
      void warmHeaderInteractionModules()
    },
    { timeout: 2500 }
  )
}

warmHeaderInteractions()
